export default __webpack_public_path__ + "static/media/logo_wiki_side_white.b89e3a3c.svg";